// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/svg/arrowDown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectType {
  width: 100%;
  border: 0;
  font-family: "Montserrat Regular";
  background-color: #F7F8FC;
  outline: none;
  padding: 10px 40px 10px 16px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 12px;
  cursor: pointer;
}

.selectType option {
  font-size: 16px;
  font-family: "Montserrat Regular";
}

.EstablishmentsUpdatePage {
  padding-left: 281px;
  background: #EFF0F4;
  width: 100%;
  height: 100vh;
}
.EstablishmentsUpdatePage .PageContent {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 56px;
}
.EstablishmentsUpdatePage .PageContent .emptyList {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.EstablishmentsUpdatePage .PageContent .LoaderContainer {
  min-height: 487px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.EstablishmentsUpdatePage .PageContent .CardsContent {
  padding-left: 20px;
  padding-top: 20px;
  background: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 36px;
}
.EstablishmentsUpdatePage .PageContent .FirstControlPanel {
  display: flex;
  gap: 40px;
}
.EstablishmentsUpdatePage .PageContent .SecondControlPanelWrapper {
  display: flex;
  gap: 48px;
}
.EstablishmentsUpdatePage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.1s;
}
.EstablishmentsUpdatePage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover {
  color: rgb(173, 164, 164);
}
.EstablishmentsUpdatePage .PageContent .SecondControlPanelWrapper .SecondControlPanelContent:hover svg path {
  transition: 0.1s;
  fill: rgb(173, 164, 164);
}

.balanceBlock {
  display: flex;
  align-items: center;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EstablishmentsUpdatePage/EstablishmentsUpdate.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,SAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;EACA,4BAAA;EAEA,gBAAA;EACA,wBAAA;EACA,qBAAA;EAEA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EACA,eAAA;AADF;;AAGA;EACE,eAAA;EACA,iCAAA;AAAF;;AAGA;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AAAF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAFN;AAKI;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAHN;AAMI;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AAJN;AAOI;EACE,aAAA;EACA,SAAA;AALN;AAQI;EACE,aAAA;EACA,SAAA;AANN;AAQM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AANR;AAQQ;EACE,yBAAA;AANV;AASY;EACE,gBAAA;EACA,wBAAA;AAPd;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAbF","sourcesContent":[".selectType {\r\n  width: 100%;\r\n  border: 0;\r\n  font-family: \"Montserrat Regular\";\r\n  background-color: #F7F8FC;\r\n  outline: none;\r\n  padding: 10px 40px 10px 16px; // отступ справа под стрелку\r\n\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n\r\n  background-image: url(\"../../../assets/svg/arrowDown.svg\"); // путь к SVG\r\n  background-repeat: no-repeat;\r\n  background-position: right 16px center; // <- меняй 16px для регулировки стрелки\r\n  background-size: 12px; // размер стрелки\r\n  cursor: pointer;\r\n}\r\n.selectType option {\r\n  font-size: 16px;\r\n  font-family: \"Montserrat Regular\";\r\n}\r\n\r\n.EstablishmentsUpdatePage {\r\n  padding-left: 281px;\r\n  background: #EFF0F4;\r\n  width: 100%;\r\n  height: 100vh;\r\n\r\n\r\n\r\n  .PageContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 32px;\r\n    margin-top: 56px;\r\n\r\n    .emptyList {\r\n      display: flex;\r\n      align-items: center;\r\n      flex-direction: column;\r\n      justify-content: center;\r\n      gap: 20px;\r\n    }\r\n\r\n    .LoaderContainer {\r\n      min-height: 487px;\r\n      height: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      align-items: center;\r\n    }\r\n\r\n    .CardsContent {\r\n      padding-left: 20px;\r\n      padding-top: 20px;\r\n      background: white;\r\n      display: flex;\r\n      justify-content: center;\r\n      flex-direction: column;\r\n      gap: 36px;\r\n    }\r\n\r\n    .FirstControlPanel {\r\n      display: flex;\r\n      gap: 40px;\r\n    }\r\n\r\n    .SecondControlPanelWrapper {\r\n      display: flex;\r\n      gap: 48px;\r\n\r\n      .SecondControlPanelContent {\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 8px;\r\n        transition: 0.1s;\r\n\r\n        &:hover {\r\n          color: rgb(173, 164, 164);\r\n\r\n          svg {\r\n            path {\r\n              transition: 0.1s;\r\n              fill: rgb(173, 164, 164);\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.balanceBlock{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectType": `selectType`,
	"EstablishmentsUpdatePage": `EstablishmentsUpdatePage`,
	"PageContent": `PageContent`,
	"emptyList": `emptyList`,
	"LoaderContainer": `LoaderContainer`,
	"CardsContent": `CardsContent`,
	"FirstControlPanel": `FirstControlPanel`,
	"SecondControlPanelWrapper": `SecondControlPanelWrapper`,
	"SecondControlPanelContent": `SecondControlPanelContent`,
	"balanceBlock": `balanceBlock`
};
export default ___CSS_LOADER_EXPORT___;
